var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.message)?_c('div',{staticClass:"text-box"},[(_vm.system)?_c('SystemMessage',{attrs:{"message":_vm.parsedMessage}}):_c('div',{staticClass:"balloon"},[_c('p',[_vm._v(_vm._s(_vm.parsedMessage))])])],1):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }